let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h5YWz")).then(() => parcelRequire('jUTzs'));